import { authedAxios } from "../utils/customHttpHeader";

const sendExpressCheckInService = async (payload) => {
  const response = await authedAxios().post(
    `/bookings/${payload?.bookingId}/send-express-check-in-message?hotelId=${payload.hotelId}`,
  );
  return response;
};

export { sendExpressCheckInService };
